import { FlexCol } from '@/components/ui/flex';
import { cn } from '@/lib/utils';
import { Database, FileText } from 'lucide-react';
import { type FC } from 'react';

export type AddItemsMode = 'files' | 'database' | null;

interface AddItemsSidebarProps {
  activeMode: AddItemsMode;
  onModeChange: (mode: AddItemsMode) => void;
}

interface SidebarButtonProps {
  icon: React.ReactNode;
  isActive: boolean;
  onClick: () => void;
}

const SidebarButton: FC<SidebarButtonProps> = ({ icon, isActive, onClick }) => {
  return (
    <button
      onClick={onClick}
      className={cn(
        'flex items-center justify-center w-9 h-8 rounded-md transition-colors',
        isActive
          ? 'bg-yellow-400 text-black'
          : 'text-black hover:bg-neutral-100 hover:text-neutral-900'
      )}
    >
      {icon}
    </button>
  );
};

export const AddItemsSidebar: FC<AddItemsSidebarProps> = ({
  activeMode,
  onModeChange,
}) => {
  const handleModeClick = (mode: AddItemsMode) => {
    // Toggle off if clicking the same mode
    if (activeMode === mode) {
      onModeChange(null);
    } else {
      onModeChange(mode);
    }
  };

  return (
    <FlexCol
      data-add-items-sidebar
      className="w-[53px] h-full bg-tan-200 border-l border-neutral-200 p-2 gap-1 flex-shrink-0 relative z-20"
    >
      <SidebarButton
        icon={<Database className="w-4 h-4" />}
        isActive={activeMode === 'database'}
        onClick={() => handleModeClick('database')}
      />
      <SidebarButton
        icon={<FileText className="w-4 h-4" />}
        isActive={activeMode === 'files'}
        onClick={() => handleModeClick('files')}
      />
    </FlexCol>
  );
};
